import { useAppDispatch } from "../redux/hooks";
import { CountryInfoType } from "../country/redux/country.types";
import { useSelector } from "react-redux";
import { selectedCountrySelector } from "../country/redux/country.selector";
import { useEffect } from "react";
import { genericActionDispatcher } from "../shared/redux/shared.slice";
import { showPageLoaderSelector } from "../shared/redux/shared.selector";

// Components imports
import HeaderComponent from "../shared/components/header/header.component";
import OfferBodyComponent from "./components/offer-body.component";
import FooterComponent from "../shared/components/footer/footer.component";
import LoaderComponent from "../shared/components/loader.component";

// Logo and image import
import mpowerLogoOffer from "../assets/logo/mpower-logo-offer.png";
import WhoBlueLogo from "../assets/logo/who-logo-blue.png";

//Interface import
import { HeaderPropType } from "../shared/components/header/header-interface";

/**
 * OfferPage component represents the main page of the Offer section.
 * It includes a header, body, and footer components.
 * @function CountryPage
 * @returns {React.JSX.Element}
 */

const headerPropData: HeaderPropType[] = [
    {
        id: "01",
        img: WhoBlueLogo,
        alt: "who-blue-logo",
        class: "whologo",
        url: "",
    },
    {
        id: "02",
        img: mpowerLogoOffer,
        alt: "mpower-offer-logo",
        class: "mpowerlogo",
        url: "/",
    },
];

const OfferPage = (): React.JSX.Element => {
    const dispatch = useAppDispatch();
    const selectedCountry: CountryInfoType = useSelector(
        selectedCountrySelector,
    );
    const showLoader = useSelector(showPageLoaderSelector);

    useEffect(() => {
        dispatch(
            genericActionDispatcher({
                selectedCountry: selectedCountry?.offerBlockPropData?.name,
                policyData: "2",
            }),
        );
    }, []);

    return (
        <>
            {showLoader ? (
                <LoaderComponent></LoaderComponent>
            ) : (
                <>
                    <HeaderComponent imgData={headerPropData} />
                    <OfferBodyComponent />
                    <FooterComponent />
                </>
            )}
        </>
    );
};

export default OfferPage;
